import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios'
import mycfg from '@/config' 

import io from 'socket.io-client'
import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'

import dd from 'dingtalk-jsapi'

Vue.use(Vuex)

async function getAuthCode() {
    return new Promise((resolve, reject) => {
        dd.ready(function() {
            dd.runtime.permission.requestAuthCode({
                corpId: mycfg.dd.corpId, // 企业id
                onSuccess: function (info) {
                    const code = info.code // 通过该免登授权码可以获取用户身份
                    console.log(`authcode:${code}`)
                    resolve(code)
                },
                onFail: err => {
                    console.log(`authcode err:${err.message}-${err.stack}`)
                    reject(err)
                } 
            });
        })
    })
}


const socket = io(mycfg.server_url, {
  transports: ['websocket'],
  forceNew: true
});
const feathers_client = feathers()

feathers_client.configure(socketio(socket))
feathers_client.configure(auth({}))

async function ddConfig() {
    const url = window.location.href.replace(window.location.hash, "")

    console.log(`ddConfig, url:${url}`)

    const ddservice = feathers_client.service('ddjsapi')
    const signinfo = await ddservice.get('sign', {query:{url}})

    dd.config({
        agentId: mycfg.dd.agentId, // 必填，微应用ID
        corpId: mycfg.dd.corpId,//必填，企业ID
        timeStamp: signinfo.timeStamp, // 必填，生成签名的时间戳
        nonceStr: signinfo.nonceStr, // 必填，生成签名的随机串
        signature: signinfo.signature, // 必填，签名
        type:0,   //选填，0表示微应用的jsapi，1表示服务窗的jsapi，不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
        jsApiList:[
            'device.notification.alert',
            'biz.contact.complexPicker',
            'biz.contact.departmentsPicker',
            'biz.contact.choose'
        ],
    })

    dd.error(err => {
        alert('dd.config error: ' + JSON.stringify(err))
    })
}

export default new Vuex.Store({
    state: {
        cur_user:null,
        loginfailed:false,
        authConfig:null,
        departmentsettings :[],
        myCurManageDepartment:null
    },
    getters: {
        client: ()=> feathers_client,
        service: () => (servicename) => feathers_client.service(servicename),
        localEnabled: (state) => !!(state.authConfig && state.authConfig.localEnabled),
        myManageDepartments: (state) =>
        state.cur_user? ((state.cur_user.isAdmin) ? state.departmentsettings :
            state.departmentsettings.filter(ds => ds.supervisorid === state.cur_user.userid))
            : []
    },
    mutations: {
        setCurUser(state, user) {
            state.cur_user = user
        },
        loginFailed(state) {
            state.loginfailed = true
        },
        resetLoginFailed(state) {
            state.loginfailed = false
        },
        setAuthConfig(state, authConfig) {
            state.authConfig = authConfig
        },
        setDepartmentSettings(state, departmentsettings) {
            state.departmentsettings = departmentsettings

            const myuserid = state.cur_user.userid
            const isAdmin = state.cur_user.isAdmin

            //check my current manage department and reset if neccesary
            if (state.myCurManageDepartment) {
                const ds = departmentsettings.find(ds => (ds.supervisorid === myuserid || isAdmin)
                    && ds.departmentid === state.myCurManageDepartment.departmentid)
                if (!ds) state.myCurManageDepartment = null
            }

            if (!state.myCurManageDepartment) {
                state.myCurManageDepartment = departmentsettings.find(ds => ds.supervisorid === state.cur_user.userid)
            }
        },
        setMyCurManageDepartment(state, dep) {
            state.myCurManageDepartment = dep
        }
    },
    actions: {
        async login({commit, state, dispatch}) {
            if (state.cur_user || state.loginfailed) return

            const authConfig = await dispatch('loadAuthConfig')
            if (authConfig.localEnabled) return

            try {
                const code = await getAuthCode()

                const authInfo = await feathers_client.authenticate({
                    strategy:'dd', code
                })

                ddConfig()

                commit('setCurUser', authInfo.user)

                dispatch('loadDepartmentSettings')
            } catch (e) {
                console.log(`login error:${e.message}-${e.stack}`)
                commit('loginFailed')
            }

        },

        async loadAuthConfig({commit, state}) {
            if (state.authConfig) return state.authConfig

            try {
                const authConfig = await feathers_client.service('authconfig').find()
                commit('setAuthConfig', authConfig)
                return authConfig
            } catch (e) {
                console.log(`authconfig error:${e.message}-${e.stack}`)
                const fallback = { localEnabled: false, strategies: ['jwt', 'dd'] }
                commit('setAuthConfig', fallback)
                return fallback
            }
        },

        async localLogin({commit, dispatch}, {userid, password}) {
            commit('resetLoginFailed')

            const authInfo = await feathers_client.authenticate({
                strategy: 'local', userid, password
            })

            commit('setCurUser', authInfo.user)
            await dispatch('loadDepartmentSettings')

            return authInfo
        },

        async loadDepartmentSettings({commit, getters}) {
            const service = getters.service('departmentsettings')
            const response = await service.find()

            const data = response.data.sort((a, b) => a < b? -1:(a == b ? 0: 1))
            commit('setDepartmentSettings', data)
        }
    }
})